// @flow

import React, { Component } from 'react'

import './ContentHashtags.css'
import Loading from '../Icons/loading.gif'

type Props = {
  hashtags: Array<string>,
  loading: Boolean
}

/**
  * Diplay for push notifications
  * @class
  * @extends Component
*/
class ContentHashtags extends Component<Props> {
  /** render function */
  render () {
    const hashtags = this.props.hashtags || []
    let hashtagsMessage = null
    if (hashtags.length === 0) {
      hashtagsMessage = 'No hashtags were used on this post'
    }
    const list = hashtags.map((hashtag) => {
      if (hashtag.name === 'Loading' || hashtag === 'OFFLINE') {
        return (<table key='Loading'><tbody><tr><td><img src={Loading} alt='Loading' /></td></tr></tbody></table>)
      }
      return (
        <div className='ContentHashtagDisplay' key={hashtag}>
          <p>#{hashtag}</p>
        </div>
      )
    })

    let body
    if (this.props.loading) body = null
    else {
      body = <>
        {list}
        <div style={{ color: '#A3AEBD', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 'fit-content' }}>
          {hashtagsMessage}
        </div>
      </>
    }
    return (
      <div className='box' style={{ minHeight: '250px', position: 'relative' }}>
        <h4>
          HASHTAGS
        </h4>
        <div style={{ maxHeight: '200px', overflow: 'auto' }}>
          {body}
        </div>

      </div>
    )
  }
}

export default ContentHashtags
